import script from "./Discogs.vue?vue&type=script&setup=true&lang=js"
export * from "./Discogs.vue?vue&type=script&setup=true&lang=js"

import "./Discogs.vue?vue&type=style&index=0&id=5a9ac3b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9ac3b1"]])

export default __exports__